<template>
  <div class="tire-maintenance">
    <div class="tire-init-box">
      <el-form ref="tireFormRef" :model="tireForm" label-width="120px" size="small" class="tire-form">
        <el-form-item label="选择车辆" prop="vehicleId" required>
          <el-select v-model="tireForm.vehicleId" filterable placeholder="请选择或输入车牌号" style="width: 220px"
            :loading="loadTiresLoading" @change="onVehicleChange">
            <el-option v-for="v in vehicleOptions" :key="v.id" :label="v.vehicleNo" :value="v.id" />
          </el-select>
          <span v-if="tireForm.vehicleId" class="vehicle-tip">已选：{{ selectedVehicleNo }}</span>
        </el-form-item>
        <el-form-item label="轮胎列表">
          <el-button type="primary" size="small" icon="el-icon-plus" @click="addTireRow">添加轮位</el-button>
          <span v-if="tireForm.tires.length" class="tire-count-tip">共 {{ tireForm.tires.length }} 条</span>
        </el-form-item>
        <el-table :data="tireForm.tires" border size="small" class="tire-table">
          <el-table-column label="轮位" width="140">
            <template slot-scope="scope">
              <el-select v-model="scope.row.position" placeholder="必填" style="width: 100%">
                <el-option v-for="p in positionOpts" :key="p.value" :label="p.label" :value="p.value" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="安装时里程(km)" width="180">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.installInitialMileage" :min="0" :max="999999"
                controls-position="right" style="width: 150px" />
            </template>
          </el-table-column>
          <el-table-column label="轮胎编号" width="160">
            <template slot-scope="scope">
              <el-input v-model="scope.row.tireCode" placeholder="选填" size="small" />
            </template>
          </el-table-column>
          <el-table-column label="品牌" width="150">
            <template slot-scope="scope">
              <el-input v-model="scope.row.brand" placeholder="选填" size="small" />
            </template>
          </el-table-column>
          <el-table-column label="尺寸" width="120">
            <template slot-scope="scope">
              <el-input v-model="scope.row.size" placeholder="如17寸" size="small" />
            </template>
          </el-table-column>
          <el-table-column label="生产日期" width="180">
            <template slot-scope="scope">
              <el-date-picker v-model="scope.row.productionDate" type="date" value-format="yyyy-MM-dd" placeholder="选填"
                size="small" style="width: 150px" />
            </template>
          </el-table-column>
          <el-table-column label="安装日期" width="180">
            <template slot-scope="scope">
              <el-date-picker v-model="scope.row.installDate" type="date" value-format="yyyy-MM-dd" placeholder="选填"
                size="small" style="width: 150px" />
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="small" class="danger-text" @click="removeTireRow(scope.$index)">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-form-item style="margin-top: 12px">
          <el-button type="primary" :loading="saveLoading" @click="saveOrCreate">保存</el-button>
          <span class="tip-text">存在即更新，不存在则创建。同一车辆下轮位不能重复。</span>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { initTire, listVehicle, listConsumable, updateConsumable } from "@/api";

const POSITION_OPTS = [
  { value: "左前", label: "左前" },
  { value: "右前", label: "右前" },
  { value: "左后", label: "左后" },
  { value: "右后", label: "右后" }
];

function mapRecordToRow(r) {
  return {
    id: r.id,
    vehicleId: r.vehicleId,
    vehicleNo: r.vehicleNo,
    position: r.position,
    installInitialMileage: r.installInitialMileage != null ? r.installInitialMileage : 0,
    tireCode: r.tireCode || "",
    brand: r.brand || "",
    size: r.size || "",
    productionDate: r.productionDate || "",
    installDate: r.installDate || "",
    runMileage: r.runMileage,
    usageDays: r.usageDays,
    unusable: r.unusable
  };
}

export default {
  name: "TireMaintenance",
  data() {
    return {
      vehicleOptions: [],
      tireForm: {
        vehicleId: null,
        tires: []
      },
      saveLoading: false,
      loadTiresLoading: false,
      positionOpts: POSITION_OPTS
    };
  },
  computed: {
    selectedVehicleNo() {
      const v = this.vehicleOptions.find((o) => o.id === this.tireForm.vehicleId);
      return v ? v.vehicleNo : "";
    },
    hasExistingTires() {
      return this.tireForm.tires.some((r) => r.id);
    }
  },
  created() {
    this.loadVehicles();
  },
  methods: {
    loadVehicles() {
      listVehicle({
        page: { current: 1, size: 500 },
        param: { status: "ACTIVE" }
      }).then((res) => {
        const data = res.data || {};
        this.vehicleOptions = data.records || [];
      });
    },
    onVehicleChange() {
      if (!this.tireForm.vehicleId) {
        this.tireForm.tires = [];
        return;
      }
      this.loadTiresLoading = true;
      listConsumable({
        page: { current: 1, size: 100 },
        param: { vehicleId: this.tireForm.vehicleId, type: "TIRE", unusable: true }
      })
        .then((res) => {
          const data = res.data || {};
          const records = data.records || [];
          this.tireForm.tires = records.map(mapRecordToRow);
        })
        .finally(() => {
          this.loadTiresLoading = false;
        });
    },
    addTireRow() {
      this.tireForm.tires.push({
        position: "",
        installInitialMileage: 0,
        tireCode: "",
        brand: "",
        size: "",
        productionDate: "",
        installDate: ""
      });
    },
    removeTireRow(index) {
      this.tireForm.tires.splice(index, 1);
    },
    saveOrCreate() {
      if (!this.tireForm.vehicleId) {
        this.$message.warning("请先选择车辆");
        return;
      }
      if (!this.tireForm.tires.length) {
        this.$message.warning("请至少添加一条轮胎记录");
        return;
      }
      const withId = this.tireForm.tires.filter((r) => r.id);
      const newRows = this.tireForm.tires.filter((r) => !r.id);
      const emptyPosition = this.tireForm.tires.some((t) => !t.position || !t.position.trim());
      if (emptyPosition) {
        this.$message.warning("请填写每条轮胎的轮位");
        return;
      }
      if (!withId.length && !newRows.length) {
        return;
      }
      this.saveLoading = true;
      const updatePromises = withId.map((row) =>
        updateConsumable({
          id: row.id,
          vehicleId: row.vehicleId,
          vehicleNo: row.vehicleNo,
          position: row.position,
          installInitialMileage: row.installInitialMileage != null ? row.installInitialMileage : 0,
          tireCode: row.tireCode || undefined,
          brand: row.brand || undefined,
          size: row.size || undefined,
          productionDate: row.productionDate || undefined,
          installDate: row.installDate || undefined
        })
      );
      const createPromise = newRows.length
        ? initTire(
          newRows.map((r) => ({
            vehicleId: this.tireForm.vehicleId,
            position: r.position,
            installInitialMileage: r.installInitialMileage != null ? r.installInitialMileage : 0,
            tireCode: r.tireCode || undefined,
            brand: r.brand || undefined,
            size: r.size || undefined,
            productionDate: r.productionDate || undefined,
            installDate: r.installDate || undefined
          }))
        )
        : Promise.resolve();
      Promise.all([...updatePromises, createPromise])
        .then(() => {
          this.$message.success("保存成功");
          this.onVehicleChange();
          this.$emit("success");
        })
        .finally(() => {
          this.saveLoading = false;
        });
    }
  }
};
</script>

<style scoped>
.tire-maintenance .tire-init-box {
  padding: 16px 0;
}

.tire-form .vehicle-tip {
  margin-left: 8px;
  color: #909399;
  font-size: 12px;
}

.tire-table {
  margin-bottom: 12px;
}

.tire-count-tip {
  margin-left: 8px;
  color: #909399;
  font-size: 12px;
}

.tip-text {
  margin-left: 12px;
  color: #909399;
  font-size: 12px;
}

.danger-text {
  color: #f56c6c;
}

.text-placeholder {
  color: #c0c4cc;
}
</style>
